import { useQuery } from '@tanstack/react-query'
import { EndpointHint } from '../../core/index.js'
import type { MessagesAdminApi } from '../adminApi.js'

/** "Texts this month: 412 (430 parts)" on the admin's client detail (SMS plan 3.8): the client's own tally, this UTC month to date. */
export function AdminClientTextsLine({ api, clientId }: { api: Pick<MessagesAdminApi, 'clientDelivery'>; clientId: string }) {
  const query = useQuery({ queryKey: ['admin', 'client', clientId, 'delivery'], queryFn: () => api.clientDelivery(clientId) })
  if (query.isPending) {
    return <p className="text-xs text-ink-mid">Texts this month: counting…</p>
  }
  if (query.isError) {
    return <p className="text-xs text-ink-mid">Texts this month: not available on this API.</p>
  }
  const sms = query.data.totals['sms']
  return (
    <p className="text-xs text-ink">
      <span className="font-bold">Texts this month:</span> {sms?.sent ?? 0} ({sms?.segments ?? 0} billable {sms?.segments === 1 ? 'part' : 'parts'})
      {sms?.failed ? <span className="text-coral"> · {sms.failed} failed</span> : null}
      <EndpointHint className="ml-2">GET /admin/clients/{'{clientId}'}/delivery</EndpointHint>
    </p>
  )
}
